<template>
  <v-container pa-0 class="hvh-criteria-builder">
    <v-form class="px-4">
      <v-flex xs7>
        <v-btn-toggle>
          <v-btn flat class="hvh-btn hvh-btn--primary hvh-toggle-btn">Simple</v-btn>
          <v-btn flat class="hvh-btn hvh-btn--secondary hvh-toggle-btn">Advanced</v-btn>
        </v-btn-toggle>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn flat icon v-on="on" class="ml-0 hvh-icon-btn">
              <v-icon small>mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Tooltip content</span>
        </v-tooltip>
      </v-flex>
    </v-form>
    <v-container>
      <v-flex xs10>
        <!-- CARD -->
        <v-card elevation="0" class="hvh-card--rounded hvh-card--border">
          <v-card-title>
            <v-toolbar flat color="white">
              <v-text-field outline label="Group Name" hide-details="true" full-width="true" />
              <v-btn flat icon class="ml-0 hvh-icon-btn">
                <v-icon small>mdi-help-circle-outline</v-icon>
              </v-btn>
              <v-btn-toggle>
                <v-btn flat class="hvh-btn hvh-btn--primary hvh-toggle-btn">And</v-btn>
                <v-btn flat class="hvh-btn hvh-btn--secondary hvh-toggle-btn">Or</v-btn>
              </v-btn-toggle>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <div class="px-4">
              <v-text-field outline full-width="true" append-icon="mdi-magnify" append-outer-icon="mdi-close" hide-details="true" label="Drug, procedure, or diagnosis"></v-text-field>
              <v-flex xs11>
                <v-layout class="pa-0 mt-2">
                  <v-flex mr-2>
                    <v-select outline :items="ocurrenceItems" label="Occurring at least"></v-select>
                  </v-flex>
                  <v-flex>
                    <v-select outline :items="separationItems" label="Separated by"></v-select>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
              </v-flex>
              <!-- SUBITEMS -->
              <div class="mt-4">
                <v-layout>
                  <v-flex xs1 mt-3 class="hvh-criteria-builder--subitem-label">
                    <v-icon small>mdi-subdirectory-arrow-right</v-icon>
                    <span pt-2>OR</span>
                  </v-flex>
                  <v-flex>
                    <v-text-field outline full-width="true" append-icon="mdi-magnify" append-outer-icon="mdi-close" hide-details="true" label="Drug, procedure, or diagnosis"></v-text-field>
                    <v-flex xs11>
                      <v-layout class="pa-0 mt-2">
                        <v-flex mr-2>
                          <v-select outline :items="ocurrenceItems" label="Occurring at least"></v-select>
                        </v-flex>
                        <v-flex>
                          <v-select outline :items="separationItems" label="Separated by"></v-select>
                        </v-flex>
                        <v-flex xs1></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </div>
              <!-- SUBITEMS -->
              <!-- ADD EVENT BUTTON -->
              <div class="mt-3">
                <v-btn flat class="hvh-txt-btn px-0 mx-0">Add Event</v-btn>
                <v-btn flat icon class="ml-0 hvh-icon-btn">
                  <v-icon small>mdi-help-circle-outline</v-icon>
                </v-btn>
              </div>
              <!-- ADD EVENT BUTTON -->
            </div>
          </v-card-text>
        </v-card>
        <!-- CARD -->
        <!-- AND/OR BUTTONS -->
        <v-flex my-3>
          <v-btn-toggle>
            <v-btn flat class="hvh-btn hvh-btn--primary hvh-toggle-btn">And</v-btn>
            <v-btn flat class="hvh-btn hvh-btn--secondary hvh-toggle-btn">Or</v-btn>
          </v-btn-toggle>
          <v-btn flat icon class="ml-0 hvh-icon-btn">
            <v-icon small>mdi-help-circle-outline</v-icon>
          </v-btn>
        </v-flex>
        <!-- AND/OR BUTTONS -->
        <!-- CARD -->
        <v-card elevation="0" class="hvh-card--rounded hvh-card--border">
          <v-card-title>
            <v-toolbar flat color="white">
              <v-text-field outline label="Group Name" hide-details="true" full-width="true" />
              <v-btn flat icon class="ml-0 hvh-icon-btn">
                <v-icon small>mdi-help-circle-outline</v-icon>
              </v-btn>
              <v-btn-toggle class="hvh-toggle-disabled">
                <v-btn flat disabled class="hvh-btn hvh-btn--primary hvh-toggle-btn">And</v-btn>
                <v-btn flat disabled class="hvh-btn hvh-btn--secondary hvh-toggle-btn">Or</v-btn>
              </v-btn-toggle>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <div class="px-4">
              <v-text-field outline full-width="true" append-icon="mdi-magnify" append-outer-icon="mdi-close" hide-details="true" label="Drug, procedure, or diagnosis"></v-text-field>
              <v-flex xs11>
                <v-layout class="pa-0 mt-2">
                  <v-flex mr-2>
                    <v-select outline :items="ocurrenceItems" label="Occurring at least"></v-select>
                  </v-flex>
                  <v-flex>
                    <v-select outline :items="separationItems" label="Separated by"></v-select>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
              </v-flex>
              <!-- ADD EVENT BUTTON -->
              <div class="mt-3">
                <v-btn flat class="hvh-txt-btn px-0 mx-0">Add Event</v-btn>
                <v-btn flat icon class="ml-0 hvh-icon-btn">
                  <v-icon small>mdi-help-circle-outline</v-icon>
                </v-btn>
              </div>
              <!-- ADD EVENT BUTTON -->
            </div>
          </v-card-text>
        </v-card>
        <!-- CARD -->
        <!-- ADD GROUP BUTTON -->
        <div class="mt-3">
          <v-btn flat class="hvh-txt-btn mx-0">Add Group of Events</v-btn>
          <v-btn flat icon class="ml-0 pa-0 hvh-icon-btn">
            <v-icon small>mdi-help-circle-outline</v-icon>
          </v-btn>
        </div>
        <!-- ADD GROUP BUTTON -->
      </v-flex>
    </v-container>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      ocurrenceItems: ['1 Time', '2 Times', '3 Times', '4 Times'],
      separationItems: ['1 Month', '2 Months', '3 Months', '4 Months'],
    }
  }
}
</script>

<style lang="scss">
.hvh-criteria-builder {
  .hvh-criteria-builder--subitem-label {
    color: $color-gray-3;
    font-size: rem(15px);

    .v-icon {
      position: relative;
      top: -2px;
    }
  }

  .v-input__append-outer {
    margin-left: 20px;
  }
}
</style>